import { FC } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

import GetAppIcon from '@mui/icons-material/GetApp';
import { Box, Tooltip } from '@mui/material';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

interface Props extends UseControllerProps {
  id?: string;
  title: string;
  downloadUrl?: string;
  fileName?: string;
  disableUpload?: boolean;
}

const Input = styled('input')({
  display: 'none',
});

export const FileInput: FC<Props> = ({
  name,
  rules,
  shouldUnregister,
  defaultValue,
  control,
  id,
  title,
  downloadUrl,
  fileName,
  disableUpload = false,
}) => {
  const { field } = useController({
    name,
    rules,
    shouldUnregister,
    defaultValue,
    control,
  });
  const text = (field.value as File)?.name || fileName || title;
  const canDownload = downloadUrl && !field?.value;

  const handleChange = (event: any) => {
    const selectedFile = event.target?.files?.[0];
    if (!selectedFile) {
      return;
    }

    field.onChange(selectedFile);
  };

  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        display="inline-flex"
        sx={{
          borderRadius: 1,
          border: '1px solid',
        }}
      >
        {!disableUpload && (
          <Box sx={{ px: 1 }}>
            <label htmlFor={id}>
              <Input
                id={id}
                accept=".pdf,.png,.jpeg,.jpg"
                type="file"
                name={name}
                onChange={handleChange}
              />

              <Tooltip title="Adicionar contrato">
                <Button component="span" color="inherit" sx={{}}>
                  Adicionar
                </Button>
              </Tooltip>
            </label>
          </Box>
        )}

        <Box sx={{ px: 1, bgcolor: '#000' }}>
          {canDownload ? (
            <Tooltip title={'Baixar contrato'}>
              <Button
                href={downloadUrl}
                endIcon={<GetAppIcon />}
                sx={{ color: '#FFF' }}
              >
                {text}
              </Button>
            </Tooltip>
          ) : (
            <Box
              sx={{
                color: '#FFF',
                height: 37,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {text}
            </Box>
          )}
        </Box>
      </Stack>
    </>
  );
};
